/* eslint-disable @typescript-eslint/no-explicit-any */
import Avatar from "common/components/Avatar"
import EstadoDocumento from "common/components/EstadoDocumento/EstadoDocumento"
import { ESTADO_REVISION_PROPERTIES } from "common/utils/constants"
import { truncateString } from "common/utils/utils"
import { rangeArrayFromNumber } from "features/User/utils"
import { Tooltip } from "primereact/tooltip"
import { useTranslation } from "react-i18next"
import { DetailStepsProps, FLOW_STATUS_KEYS } from "../../../constant"
import DetailStepItem from "./component/DetailStepItem"
import DetailStepStatus from "./component/DetailStepStatus"

const DetailSteps: React.FC<DetailStepsProps> = ({
  etapa,
  flexContainer,
  isEtapaRejected,
  isVistaDetail,
  etapas,
}) => {
  const { t } = useTranslation()
  const checkEtapasStatus = (status: $TSMigrationFixMe) =>
    etapa?.firmantes?.filter((el: $TSMigrationFixMe) => el.estado === status)
  const etapaRejected = checkEtapasStatus(FLOW_STATUS_KEYS[3].value)
  const etapasApproved = checkEtapasStatus(FLOW_STATUS_KEYS[2].value)
  const isEtapaCompleted = etapa.estado === FLOW_STATUS_KEYS[2].value
  const estapaPreviousStatus = etapas?.[etapas.length - 2]?.estado

  const currentEtapa = etapas.find((etapa) => etapa.estado === 1)

  const getRemainingFirmantes = () => {
    if (!isEtapaCompleted) {
      if (etapasApproved.length > 2) {
        return etapasApproved.slice(0, etapasApproved.length - 1)
      }
    } else if (isEtapaCompleted) {
      if (etapasApproved.length > 2) {
        return etapasApproved.slice(0, etapasApproved.length - 2)
      }
    }
    if (etapasApproved.length === 2) {
      return [etapasApproved[0]]
    }
  }

  const remainingFirmantes = etapa?.firmantes && getRemainingFirmantes()

  const getFirmantesArray = () => {
    if (etapa?.firmantes?.length) {
      return rangeArrayFromNumber(
        2,
        etapa?.numeroFirmas - etapa?.firmantes.length,
        1
      ).fill(etapa.numeroFirmas)
    }
    return rangeArrayFromNumber(2, etapa?.numeroFirmas, 1).fill(
      etapa.numeroFirmas
    )
  }

  const validateTotalSigns = (firmantesArray: $TSMigrationFixMe[]) => {
    if (firmantesArray?.length > 1) {
      return ` (${firmantesArray?.length})`
    }
    return ""
  }
  const checkIfTextIsDisabled = () => {
    if (
      etapa.departamentoNombre === currentEtapa?.departamentoNombre &&
      currentEtapa?.estado === 1
    ) {
      return false
    }
    if (estapaPreviousStatus !== 2 && !etapa.firmantes?.length) {
      return true
    }
    return false
  }
  const getAvatanColor = (): string | undefined => {
    if (etapas.length === 1 && etapa.estado === 1) {
      return FLOW_STATUS_KEYS[etapa.estado]?.backgroundColor
    }
    if (
      (!FLOW_STATUS_KEYS[etapa.estado]?.icon && isEtapaRejected) ||
      (estapaPreviousStatus !== 2 && !etapa.firmantes?.length)
    )
      return "tw-bg-primary"

    return FLOW_STATUS_KEYS[etapa.estado]?.backgroundColor
  }

  const getLastFirmante = () => {
    if (!isEtapaCompleted) {
      if (etapasApproved.length > 2) {
        return etapasApproved[etapasApproved.length - 1]
      }
    } else if (isEtapaCompleted) {
      if (etapasApproved.length > 2) {
        return etapasApproved[etapasApproved.length - 2]
      }
    }
    if (etapasApproved.length === 2) {
      return etapasApproved[1]
    }
    return etapasApproved[0]
  }
  return (
    <div
      className={`${
        flexContainer ? "tw-flex" : "tw-grid tw-gap-3 tw-grid-cols-[1fr_10fr]"
      } tw-relative before:tw-content-[''] before:tw-absolute before:tw-top-12 before:tw-left-5 before:tw-h-[80%] before:tw-w-1 before:tw-border-r-2 before:tw-border-dotted before:tw-border-[#c1b8b8]
 `}
    >
      <Avatar
        initials={etapa.departamentoNombre.slice(0, 2).toUpperCase() ?? ""}
        iconName={FLOW_STATUS_KEYS[etapa.estado].icon}
        iconColor={FLOW_STATUS_KEYS[etapa.estado].iconColor}
        backgroundColor={getAvatanColor()}
        borderColor={FLOW_STATUS_KEYS[etapa.estado].iconColor}
      />
      <div
        key={Math.random()}
        className='tw-text-left'
      >
        <div className='tw-mb-2 tw-flex tw-justify-between tw-items-center'>
          <p
            className={`tw-font-medium ${
              checkIfTextIsDisabled() ? "tw-opacity-50" : ""
            }`}
          >
            {etapa.departamentoNombre}
          </p>
          <EstadoDocumento
            color={ESTADO_REVISION_PROPERTIES(t)[etapa.estado].color}
            text={ESTADO_REVISION_PROPERTIES(t)[etapa.estado].text}
            className='tw-flex tw-justify-end tw-p-0'
            disabled={checkIfTextIsDisabled()}
            fontSize='14px'
            padding='0'
            backgroundColor={undefined}
            width={undefined}
          />
        </div>
        <ul className='tw-p-0 tw-mt-2'>
          <>
            {etapasApproved?.length ? (
              <>
                <DetailStepStatus
                  icon={FLOW_STATUS_KEYS[getLastFirmante()?.estado]?.icon}
                  status={FLOW_STATUS_KEYS[getLastFirmante()?.estado]?.status}
                  date={getLastFirmante()?.fecha}
                  description={getLastFirmante()?.descripcion}
                >
                  <div className='tw-relative tw-flex tw-flex-col tw-gap-1'>
                    <p className='tw-text-sm'>
                      {isVistaDetail
                        ? getLastFirmante()?.firmanteNombre
                        : truncateString({
                            str: getLastFirmante()?.firmanteNombre || "",
                            maxLength: 14,
                          })}
                      {remainingFirmantes?.length ? (
                        <>
                          <span
                            className='tw-text-primary tw-cursor-pointer'
                            id={`span-id${remainingFirmantes[0].id}`}
                          >{` (${remainingFirmantes.length} más)`}</span>
                          <Tooltip
                            target={`#span-id${remainingFirmantes[0].id}`}
                            autoHide={false}
                            hideDelay={1000}
                            content=''
                          />
                          {/* <ul className='tw-p-2'>
                            {remainingFirmantes.map(
                              (firmante: $TSMigrationFixMe) => (
                                <li
                                  key={remainingFirmantes[0].id}
                                  className='tw-list-none'
                                >
                                  <div className='tw-flex tw-justify-between tw-gap-3'>
                                    <span className='tw-text-xs'>
                                      {truncateString({
                                        str: firmante?.firmanteNombre || "",
                                        maxLength: 22,
                                      })}
                                    </span>
                                    <div className='tw-text-xs'>
                                      {formatDate(
                                        firmante.fecha,
                                        CURRENT_DATE_FORMAT_WITH_HOURS
                                      )}
                                    </div>
                                  </div>
                                  {firmante.descripcion ? (
                                    <p className='tw-text-xs tw-w-60'>
                                      {firmante.descripcion}
                                    </p>
                                  ) : null}
                                </li>
                              )
                            )}
                          </ul> */}
                        </>
                      ) : null}
                    </p>
                  </div>
                </DetailStepStatus>
                {isEtapaCompleted && etapa.numeroFirmas > 1 ? (
                  <DetailStepStatus
                    icon={
                      FLOW_STATUS_KEYS[
                        etapasApproved[etapasApproved.length - 1].estado
                      ]?.icon
                    }
                    status={
                      FLOW_STATUS_KEYS[
                        etapasApproved[etapasApproved.length - 1].estado
                      ]?.status
                    }
                    date={etapasApproved[etapasApproved.length - 1].fecha}
                    description={
                      etapasApproved[etapasApproved.length - 1].descripcion
                    }
                  >
                    <div className='tw-relative tw-flex tw-flex-col tw-gap-1'>
                      <p className='tw-text-sm'>
                        {isVistaDetail
                          ? etapasApproved[etapasApproved.length - 1]
                              ?.firmanteNombre
                          : truncateString({
                              str: etapasApproved[etapasApproved.length - 1]
                                ?.firmanteNombre,
                              maxLength: 14,
                            })}{" "}
                        (R)
                      </p>
                    </div>
                  </DetailStepStatus>
                ) : null}
              </>
            ) : null}
            {etapaRejected?.length ? (
              <DetailStepStatus
                icon={FLOW_STATUS_KEYS[etapaRejected[0].estado]?.smallIcon}
                status={FLOW_STATUS_KEYS[etapaRejected[0].estado]?.status}
                date={etapaRejected[0].fecha}
                description={etapaRejected[0]?.descripcion}
              >
                <div className='tw-relative tw-flex tw-flex-col tw-gap-1'>
                  <p className='tw-text-sm'>
                    {etapaRejected[0].firmanteNombre}
                  </p>
                </div>
              </DetailStepStatus>
            ) : null}
          </>
          <>
            {getFirmantesArray().length ? (
              <DetailStepItem
                isEtapaRejected={isEtapaRejected}
                etapa={etapa}
                userType={t("crear.presupuesto.modal.employeeLabel")}
                validateTotalSigns={validateTotalSigns}
                getFirmantesArray={getFirmantesArray}
                isCurrentStep={
                  FLOW_STATUS_KEYS[etapa.estado].value === 1 &&
                  etapa.firmantes?.length
                }
                disabled={checkIfTextIsDisabled()}
              />
            ) : null}
          </>

          {etapa.numeroFirmas !== etapa.firmantes?.length && (
            <DetailStepItem
              isEtapaRejected={isEtapaRejected}
              etapa={etapa}
              userType={t("crear.presupuesto.modal.responsibleLabel")}
              isCurrentStep={Boolean(!getFirmantesArray().length)}
              disabled={checkIfTextIsDisabled()}
              validateTotalSigns={undefined}
              getFirmantesArray={undefined}
            />
          )}
        </ul>
      </div>
    </div>
  )
}

export default DetailSteps
